export { getMarkup } from './templates';
export { getStyles } from './stylesheets';
export const availableTemplates = {
  radio: {
    isAdvanced: false,
    name: 'radio'
  },
  cart: {
    isAdvanced: false,
    name: 'cart'
  },
  toggle: {
    isAdvanced: false,
    name: 'toggle'
  },
  select: {
    isAdvanced: false,
    name: 'select'
  },
  'side-by-side': {
    isAdvanced: false,
    name: 'side-by-side'
  },
  buttons: {
    isAdvanced: true,
    name: 'buttons'
  },
  'read-only': {
    isAdvanced: true,
    name: 'read-only',
    defaultPreviewMode: 'subscribed'
  },
  'prepaid-enabled-radio': {
    isAdvanced: true,
    name: 'prepaid-enabled-radio',
    defaultPreviewMode: 'prepaid'
  },
  'prepaid-option': {
    isAdvanced: true,
    name: 'prepaid-option',
    defaultPreviewMode: 'prepaid'
  },
  'prepaid-enabled-cart': {
    isAdvanced: true,
    name: 'prepaid-enabled-cart',
    defaultPreviewMode: 'prepaid'
  }
};
